export default __webpack_public_path__ + "static/illustration-ro-2bdfd6d674e6d6fe7ab5d00d9d17525d.png";